module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    staticClass: "fill-current w-6 h-6",
    attrs: {
      "viewBox": "0 0 64 64",
      "width": "512",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M33 63h30V39H33zm12-22h6v2h-6zm-10 0h8v4h10v-4h8v20H35z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M57 57h2v2h-2zM53 57h2v2h-2zM49 57h2v2h-2zM61 21h-2V1H33v20h-2V1H5v20H3c-1.103 0-2 .897-2 2v2c0 1.103.897 2 2 2h5.263A7.953 7.953 0 0 0 8 29a7.996 7.996 0 0 0 3.585 6.665C5.462 37.555 1 43.265 1 50a5.003 5.003 0 0 0 3 4.576V63h27V50c0-6.735-4.462-12.445-10.585-14.335A7.996 7.996 0 0 0 24 29c0-.692-.097-1.359-.263-2H61c1.103 0 2-.897 2-2v-2c0-1.103-.897-2-2-2zM43 3h6v2h-6zm-8 0h6v4h10V3h6v18h-6v-4H41v4h-6zm14 18h-6v-2h6zM15 3h6v2h-6zM7 3h6v4h10V3h6v18h-6v-4H13v4H7zm8 18v-2h6v2zM3 25v-2h7.726a8.069 8.069 0 0 0-1.644 2zm3 30h4v6H6zm9.5-7H12v-5h7v5h5v13H12v-6h3.5c1.93 0 3.5-1.57 3.5-3.5S17.43 48 15.5 48zm5.5-3.586L22.586 46H21zM29 50v11h-3V46.586L20.414 41H10v7H7v2h8.5c.827 0 1.5.673 1.5 1.5s-.673 1.5-1.5 1.5H6c-1.654 0-3-1.346-3-3 0-7.168 5.832-13 13-13s13 5.832 13 13zM16 35c-3.309 0-6-2.691-6-6s2.691-6 6-6 6 2.691 6 6-2.691 6-6 6zm45-10H22.918a8.047 8.047 0 0 0-1.644-2H61zM49 53h10v2H49z"
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7085049f","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Icons/SupplierIcon.vue
// module id = 623
// module chunks = 66